var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"l-button",class:{ 'l-button--success': _vm.type === 'success', 'l-button--warning': _vm.type === 'warning', 'l-button--danger': _vm.type === 'danger' },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }